import axios from 'axios'
import Web3 from 'web3'

import { stringifyParams } from '/src/helpers/CoreApi'

const client = axios.create({
  baseURL: 'https://api.opensea.io/api/v1',
  headers: { 'Content-Type': 'application/json' },
})

client.interceptors.request.use(async (reqConfig) => {
  return reqConfig
})

const SALE_TYPES = {
  0: 'fixed price',
  1: 'auction',
}

export class OpenseaApi {
  static async getAssets(contract, tokenIDs) {
    try {
      const { data } = await client.get(
        `/assets?asset_contract_address=${contract}&include_orders=true&token_ids=${tokenIDs.join(
          '&token_ids='
        )}`
      )
      return data.assets.map((asset) => {
        const resultAsset = {
          tokenId: Number(asset.token_id),
          name: asset.name,
          description: asset.description,
          owner: asset.owner.address.toLowerCase(),
          ownerName: asset.owner.user ? asset.owner.user.username : '',
        }
        if (asset.sell_orders && asset.sell_orders.length > 0) {
          const order = asset.sell_orders[0]
          const symbol = order.payment_token_contract.symbol.toLowerCase()
          if (symbol === 'eth' || symbol === 'weth') {
            resultAsset.symbol = symbol
          }
          resultAsset.price = Number(
            Web3.utils.fromWei(order.base_price, 'ether')
          )
        } else if (
          asset.seaport_sell_orders &&
          asset.seaport_sell_orders.length > 0
        ) {
          const order = asset.seaport_sell_orders[0]
          resultAsset.symbol = 'eth'
          resultAsset.price = Number(
            Web3.utils.fromWei(order.current_price, 'ether')
          )
        }
        return resultAsset
      })
    } catch (error) {
      console.log(error)
      return []
    }
  }
}
